import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { LaunchProvider } from './contexts/LaunchContext';
import { CookieBanner } from './components/CookieBanner';
import { Home } from './pages/Home';
import { CookiePolicy } from './pages/CookiePolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { Disclaimer } from './pages/Disclaimer';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { About } from './pages/About';
import { DeleteAccount } from './pages/DeleteAccount';
import { NotFound } from './pages/NotFound';
type LaunchState = 'pre-launch' | 'public-launch';

/**
 * Resets scroll on navigation, except when the URL carries a hash so in-page
 * anchors (for example /#features from another page) still work.
 */
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
export function App({
  launchState = 'public-launch'
}: {
  launchState?: LaunchState;
}) {
  return <LaunchProvider launchState={launchState} data-id="element-0" data-mp="3mjq2lgp4euvl">
      <ScrollToTop data-id="element-1" data-mp="3rbra6pbcfxfa" />
      <Routes data-id="element-2" data-mp="3rdas0kcnegj6">
        <Route path="/" element={<Home data-id="element-4" data-mp="3reccfffk0fdk" />} data-id="element-3" data-mp="3rcsy3udgkeef" />
        <Route path="/cookie-policy" element={<CookiePolicy data-id="element-6" data-mp="4wx1t3d72hu" />} data-id="element-5" data-mp="5yhgo69t1c8" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-8" data-mp="2zld0746gb58w" />} data-id="element-7" data-mp="56lvdcob3ly" />
        <Route path="/terms" element={<TermsAndConditions data-id="element-10" data-mp="2zmwit1fkxsdu" />} data-id="element-9" data-mp="2zm4zaoz9bl3x" />
        <Route path="/disclaimer" element={<Disclaimer data-id="element-12" data-mp="33nq6put0v76q" />} data-id="element-11" data-mp="33morde4z3yj7" />
        <Route path="/contact" element={<Contact data-id="element-14" data-mp="38lrnua6w0wfk" />} data-id="element-13" data-mp="33mym1f0yqtv8" />
        <Route path="/faq" element={<FAQ data-id="element-16" data-mp="38l05w267qx7r" />} data-id="element-15" data-mp="38l8h7pmotugu" />
        <Route path="/about" element={<About data-id="element-18" data-mp="3dkuws5pznmst" />} data-id="element-17" data-mp="38kgmsi4tu2s5" />
        <Route path="/delete-account" element={<DeleteAccount data-id="element-20" data-mp="3dmfo7mh0apmg" />} data-id="element-19" data-mp="3dle46si0issl" />
        <Route path="*" element={<NotFound data-id="element-22" data-mp="nw2ay2pqvkpi" />} data-id="element-21" data-mp="3dii5h1ycc033" />
      </Routes>
      <CookieBanner data-id="element-23" data-mp="nuraabrlit2m" />
    </LaunchProvider>;
}